import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-incentives",
  templateUrl: "./incentives.component.html",
  styleUrls: ["./incentives.component.scss"],
})
export class IncentivesComponent implements OnInit {
  lif: any;
  lift = [];
  displayStyles = "block";
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.displayStyles = "block";
    this.http.get(environment.API_URL + "getInc/").subscribe((Response) => {
      if (Response) {
      }
      this.lif = Response;
      this.lift = this.lif.incent;
      this.displayStyles = "none";
    });
  }
}
